<template>
    <card-collapsable title="Dados de sensores" start-visible>
        <b-row align-h="center" cols="1">
            <b-col>
                <b-form-group>
                    <b-form-radio-group
                        id="radio-group-sensors"
                        v-model="selectedType"
                        :options="availableTypes"
                        :disabled="loading"
                        name="radio-group-sensors"
                        class="text-center"
                    />
                </b-form-group>
            </b-col>
            <b-col>
                <sensor-selector
                    :selected-type="selectedType"
                    :disabled="loading"
                    @change-selected="changeSelected"
                />
            </b-col>
            <b-col v-if="hasTemperatures" class="text-center mt-3">
                <b-form-checkbox
                    id="include_temperature_id"
                    v-model="includeTemperature"
                    name="include_temperature"
                    :disabled="loading"
                    :value="true"
                    :unchecked-value="false"
                >
                    Incluir eixo de temperatura
                </b-form-checkbox>
            </b-col>
            <b-col v-if="hasQuotaFlux" class="text-center mt-3">
                <b-form-checkbox
                    id="include_quota_flux_id"
                    v-model="includeQuotaFlux"
                    name="include_quota_fux"
                    :disabled="loading"
                    :value="true"
                    :unchecked-value="false"
                >
                    Incluir eixo de cota montante
                </b-form-checkbox>
            </b-col>
            <b-col class="mt-3">
                <date-range-selector
                    ref="dateSelector"
                    label="Intervalo de tempo"
                    :disabled="loading"
                />
            </b-col>
            <b-col class="text-center">
                <b-overlay
                    :show="loading"
                    class="d-inline-block"
                    variant="white"
                    spinner-small
                >
                    <b-button
                        class="pl-1"
                        :disabled="loading || !canUpdate"
                        @click="update"
                    >
                        <i class="fas fa-sm fa-sync-alt mx-1" />
                        Atualizar gráfico
                    </b-button>
                </b-overlay>
            </b-col>
        </b-row>
    </card-collapsable>
</template>

<script>
import CardCollapsable from "@/components/CardCollapsable";
import DateRangeSelector from "@/components/DateRangeSelector";
import SensorSelector from "./SensorSelector";
import { SensorReadingKind } from "@/modules/common/settings";
import hasProperty from "@/utils/hasProperty";
import { ESensor } from "../../../store/sensors";

export default {
    name: "SensorFilters",
    components: {
        CardCollapsable,
        SensorSelector,
        DateRangeSelector
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        settings: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedType: -1,
            includeTemperature: false,
            canUpdate: false,
            includeQuotaFlux: false
        };
    },
    computed: {
        availableTypes() {
            return this.$store.getters["common/sensors/availableTypes"];
        },
        hasTemperatures() {
            return hasProperty(
                this.settings.SENSOR_UNITS[this.selectedType],
                SensorReadingKind.TEMPERATURE
            );
        },
        hasQuotaFlux() {
            return this.selectedType === ESensor.PIEZOMETER;
        }
    },
    created() {
        this.selected = [];
        this.selectedType = this.availableTypes[0].value;
    },
    methods: {
        changeSelected(selected) {
            this.selected = selected;
            this.canUpdate = selected.length > 0;
        },
        update() {
            const includeTemperature = this.hasTemperatures
                ? this.includeTemperature
                : false;
            const data = {
                sensors: this.selected.map(item => item.id),
                includeTemperature,
                includeQuotaFlux: this.hasQuotaFlux
                    ? this.includeQuotaFlux
                    : false,
                sensorKind: this.selectedType,
                ...this.$refs.dateSelector.value
            };

            this.$emit("update", data);
        }
    }
};
</script>
